var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RhfFieldError, rhfMapperReq, useController, } from '@isyc-react/form/modules/rhf';
import { getParameterDisabled, validBailleursParameter } from './rhf-input-bailleurs-parameter.component';
import { useFormCommonProps } from '@isyc-react/form/modules/context/form-common';
import { InputCheckbox } from '@isyc-react/form/modules/input/option';
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
export const InputParameterBooleanCheckbox = props => {
    const _a = useFormCommonProps(props), { value, data, onChange, readOnly, disabled, justify, getDisabled = getParameterDisabled } = _a, rest = __rest(_a, ["value", "data", "onChange", "readOnly", "disabled", "justify", "getDisabled"]);
    // TODO use comboCodeLabel as default selected label in the select and defaultvalues options
    const { value: parameterValue, comboCodeLabel, relatedObjectName, relatedObjectType } = value;
    const { parameterType, obligatory, parameterId } = data;
    const parameterDisabled = React.useMemo(() => getDisabled(data, readOnly, disabled), [data, readOnly, disabled]);
    const parameterChange = React.useCallback((field) => {
        onChange && onChange(Object.assign(Object.assign({}, value), field));
    }, [value, onChange]);
    return (React.createElement(InputCheckbox, Object.assign({ value: { checked: parameterValue === 'true' }, onChange: change => parameterChange({ value: change.checked ? 'true' : 'false' }), disabled: parameterDisabled }, rest)));
};
export const RhfInputBailleursParameterBooleanCheckbox = props => {
    var _a;
    const { rhf, errorMessage, input, remarks } = props;
    const _b = input !== null && input !== void 0 ? input : {}, { label } = _b, rest = __rest(_b, ["label"]);
    const { field: { onChange, onBlur, name, value, ref }, fieldState: { error }, } = useController(rhfMapperReq(rhf, (p) => Boolean(p.value), {
        valid: (p) => validBailleursParameter(p.value, p),
    }));
    const data = value;
    const required = (_a = rhf.rules) === null || _a === void 0 ? void 0 : _a.required;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(InputParameterBooleanCheckbox, Object.assign({ onChange: onChange, onBlur: onBlur, value: value, data: data, error: Boolean(error), getDisabled: getParameterDisabled }, rest),
                label ? label : data.label,
                (data.obligatory || required) && React.createElement("span", { className: 'required' }, "*"),
                (remarks || data.remarks) && (React.createElement(OverlayTrigger, { delay: { show: 250, hide: 0 }, overlay: React.createElement(Tooltip, null, remarks || data.remarks) },
                    React.createElement("i", { className: 'mdi mdi-information text-light-secondary ms-2' })))),
            React.createElement(RhfFieldError, { errorMessage: errorMessage, error: error }))));
};
